"use client";

import { c as _c } from "react/compiler-runtime";
import { useFilterSearch } from "@repo/design-system/hooks/use-filter-search";
import { useFilterSearchState } from "@repo/design-system/hooks/use-filtersearch-state";
import { useGeoSearch } from "@repo/design-system/hooks/use-geosearch";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import { usePostingDateFilter } from "@repo/design-system/hooks/use-posting-date";
import { useSearchqueryState } from "@repo/design-system/hooks/use-searchquery-state";
import { useEffect } from "react";
import type { Job } from "~/types/job";
import { dataLayerPush } from "./data-layer-push";
import { trackingOnFilterSearch } from "./filter-search-state";
import { trackingOnFilterChange } from "./filter-used";
import { trackingForJobAd } from "./job-ad";
import { trackingOnLanguageChange } from "./language-change";
import { trackingOnPostingDateChange } from "./posting-date";
import { trackingOnSearchQueryChange } from "./search-query";
let GEO_CACHE: string | undefined;
export function TrackFilters() {
  const $ = _c(3);
  const [state] = useFilterSearchState();
  let t0;
  let t1;
  if ($[0] !== state) {
    t0 = () => {
      trackingOnFilterChange(state);
    };
    t1 = [state];
    $[0] = state;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
export function TrackGeofilter() {
  const $ = _c(5);
  const {
    geoLocation
  } = useGeoSearch();
  let t0;
  if ($[0] !== geoLocation?.name || $[1] !== geoLocation?.placeId) {
    t0 = () => {
      if (GEO_CACHE !== geoLocation?.name) {
        dataLayerPush({
          event: "jobboard_geosearch_used",
          geosearchPlaceName: geoLocation?.name,
          geosearchPlaceId: geoLocation?.placeId
        });
        GEO_CACHE = geoLocation?.name;
      }
    };
    $[0] = geoLocation?.name;
    $[1] = geoLocation?.placeId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== geoLocation) {
    t1 = [geoLocation];
    $[3] = geoLocation;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  return null;
}
export function TrackSearch() {
  const $ = _c(3);
  const [state] = useSearchqueryState();
  let t0;
  let t1;
  if ($[0] !== state) {
    t0 = () => {
      trackingOnSearchQueryChange(state);
    };
    t1 = [state];
    $[0] = state;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
export function TrackFilterState() {
  const $ = _c(13);
  const {
    data
  } = useFilterSearch();
  const {
    geoLocation
  } = useGeoSearch();
  const [state] = useSearchqueryState();
  const [filterState] = useFilterSearchState();
  const {
    postingDateFilter
  } = usePostingDateFilter();
  let t0;
  if ($[0] !== data?.pageParams || $[1] !== filterState || $[2] !== geoLocation?.name || $[3] !== geoLocation?.placeId || $[4] !== postingDateFilter || $[5] !== state) {
    t0 = () => {
      const filter = Object.entries(filterState).flatMap(_temp);
      const page = (data?.pageParams.at(-1) ?? 0) as number;
      trackingOnFilterSearch({
        params: {
          searchQuery: state ?? "",
          filter: String(filter.map(_temp2)),
          geosearchPlaceId: geoLocation?.placeId,
          geosearchPlaceName: geoLocation?.name,
          postingDateFilter
        },
        page
      });
    };
    $[0] = data?.pageParams;
    $[1] = filterState;
    $[2] = geoLocation?.name;
    $[3] = geoLocation?.placeId;
    $[4] = postingDateFilter;
    $[5] = state;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== data || $[8] !== filterState || $[9] !== geoLocation || $[10] !== postingDateFilter || $[11] !== state) {
    t1 = [data, filterState, geoLocation, state, postingDateFilter];
    $[7] = data;
    $[8] = filterState;
    $[9] = geoLocation;
    $[10] = postingDateFilter;
    $[11] = state;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  useEffect(t0, t1);
  return null;
}
function _temp2(f) {
  return f;
}
function _temp(t0) {
  const [k, v] = t0;
  return v ? [k] : [];
}
export function TrackPostingDate() {
  const $ = _c(3);
  const {
    postingDateFilter
  } = usePostingDateFilter();
  let t0;
  let t1;
  if ($[0] !== postingDateFilter) {
    t0 = () => {
      trackingOnPostingDateChange(postingDateFilter);
    };
    t1 = [postingDateFilter];
    $[0] = postingDateFilter;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
export function TrackJobad(t0) {
  const $ = _c(3);
  const {
    job
  } = t0;
  let t1;
  let t2;
  if ($[0] !== job) {
    t1 = () => {
      trackingForJobAd(job);
    };
    t2 = [job];
    $[0] = job;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}
export function TrackLanguage() {
  const $ = _c(3);
  const locale = useLocale();
  let t0;
  let t1;
  if ($[0] !== locale) {
    t0 = () => {
      trackingOnLanguageChange(locale);
    };
    t1 = [locale];
    $[0] = locale;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}